import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@veracity/vui'

import { userAdministrationClient } from '@/api'

const BASE_QUERY_KEY = userAdministrationClient.QUERY_KEY
export const useOrganizationUsers = (organizationId: number) => {
  const QUERY_KEY = [...BASE_QUERY_KEY, 'organizations', organizationId]

  const { showSuccess } = useToast()
  const queryClient = useQueryClient()

  const getOrganizationUsersQuery = useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => userAdministrationClient.getOrganizationUsers(organizationId)
  })

  const updateUserStatusMutation = useMutation({
    mutationFn: userAdministrationClient.setUserStatus,
    onSuccess: async () => {
      showSuccess('User status successfully updated')
      await queryClient.invalidateQueries({ queryKey: QUERY_KEY })
    }
  })

  const updateUserRoleMutation = useMutation({
    mutationFn: userAdministrationClient.setUserRole,
    onSuccess: async () => {
      showSuccess('User role successfully updated')
      await queryClient.invalidateQueries({ queryKey: QUERY_KEY })
    }
  })

  const detachUserFromOrganizationMutation = useMutation({
    mutationFn: userAdministrationClient.detachUserFromOrganization,
    onSuccess: async () => {
      showSuccess('User successfully detached from organization')
      await queryClient.invalidateQueries({ queryKey: QUERY_KEY })
    }
  })

  return {
    users: getOrganizationUsersQuery.data || [],
    isFetching: getOrganizationUsersQuery.isFetching,
    updateUserStatus: updateUserStatusMutation.mutate,
    updateUserRole: updateUserRoleMutation.mutate,
    detachUserFromOrganization: detachUserFromOrganizationMutation.mutate
  }
}
